<template>
  <b-button class="p-0 avatar-sm rounded-circle bottom-right" variant="main-green"
            v-show="scrollVisible" @click="scrollTop">
    <span class="avatar-title bg-transparent text-reset font-size-22">
      <i class="bx bx-up-arrow-alt" />
    </span>
  </b-button>
</template>

<script>
export default {
  data () {
    return {
      scrollVisible: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollListener);
  },
  methods: {
    // scrollTop() {
    //   this.intervalId = setInterval(() => {
    //     if (window.pageYOffset === 0) {
    //       clearInterval(this.intervalId);
    //     }
    //     window.scroll(0, window.pageYOffset - 50);
    //   }, 50);
    // },
    scrollTop() {
        window.scroll({ left: 0, top: 0, behavior: "smooth" });
    },
    scrollListener(e) {
      this.scrollVisible = window.scrollY > 150
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollListener);
  }
}
</script>

<style lang="scss" scoped>
.bottom-right {
  position: fixed;
  bottom: 20px;
  right: 20px;
  cursor: pointer;
  z-index: 99;
}
</style>
